import { render, staticRenderFns } from "./CrudNew.vue?vue&type=template&id=7dc6425d&"
import script from "./CrudNew.vue?vue&type=script&lang=js&"
export * from "./CrudNew.vue?vue&type=script&lang=js&"
import style0 from "./CrudNew.vue?vue&type=style&index=0&id=7dc6425d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports